import {
  Box,
  CircularProgress,
  Dialog,
  Divider,
  IconButton,
  InputAdornment,
  Button,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { color } from "../../../../StyleData/Config";
import { AccountTree, Save } from "@mui/icons-material";
import { Clear } from "@mui/icons-material";
import { move, useFormik } from "formik";

import AssetIdFilter from "../../../Tree/AssetIdTree";
import { axiosPrivate } from "../../../../axios/axios";
import { masterAPI } from "../../../Masters/dataConfig";
import LocationTreeView from "../locationTreeView";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const Transfer = ({ data, getData,enableDisable }) => {
  const trueDisable=!enableDisable.edit
  const [loading, setLoading] = useState(false);
  const [asset, setAsset] = useState({
    name: "",
    id: data.parentAssetId || "",
    code: "",
  });
  // const [currentLocation, setCurrentLocation] = useState({ name: data.locationName||"", id: data.locationId||"",code:data.locationCode||"" });
  const [toLocation, setToLocation] = useState({ name: "", id: "", code: "" });
  const [locationType, setLocationType] = useState("");
  const [locationDialog, setLocationDialog] = useState(false);
  const [disableLocation, sedisableLocation] = useState(false);
  const [disableAsset, setdisableAsset] = useState(false);
  const [assetDialog, setAssetDialog] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const loginInfo = useSelector((state) => state.auth.loginInfo.siteId);
  console.log("data", data.parentAssetId);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      fromParentAssetId: data.parentAssetId || null,
      fromParentAssetName: data.parentAssetName || "",
      fromParentAssetCode: data.parentAssetCode || "",
      toParentAssetId: asset.id || data.parentAssetId || null,
      toParentAssetName: asset.name || "",
      toParentAssetCode: asset.code || "",
      fromLocationCode: data.locationCode || "",
      fromLocationName: data.locationName || "",
      fromLocationId: data.locationId || null,
      toLocationCode: toLocation.code || "",
      toLocationId: toLocation.id || data.locationId || null,
      toLocationName: toLocation.name || "",
      remarks: "",
    },
    enableReinitialize: true,
    onSubmit: async (value) => {
      setLoading(true);
      const postData = {
        assetId: data.id,
        siteId: loginInfo,
        ...value,
      };
      const movementLink = masterAPI["assetMovement"].create;
      console.log(postData);
      // if (data.parentAssetId) {
      //   const isLocationChanged = value.toLocationId !== data.locationId;
      //   const isParentChanged = value.toParentAssetId !== data.parentAssetId;
      //   if (isParentChanged && isLocationChanged) {
      //     toast.error(
      //       "Cannot transfer both Parent Asset and Location at the same time."
      //     );
      //     setLoading(false);
      //     return false;
      //   }
      // }
      // if (data.parentAssetId) {
      //   const isLocationChanged = value.toLocationId === data.locationId;
      //   if (isLocationChanged) {
      //     toast.error("Cannot transfer both Same Location.");
      //     setLoading(false);
      //     return false;
      //   }
      // }
      // if (data.parentAssetId) {
      //   const isParentChanged = value.toParentAssetId === data.parentAssetId;
      //   if (isParentChanged) {
      //     toast.error("Cannot transfer both Same Parent Asset.");
      //     setLoading(false);
      //     return false;
      //   }
      // }
      if (data.id === value.toParentAssetId) {
        toast.error("Asset cannot be set as its own parent.");
        return false;
      }
      await axiosPrivate
        .post(`${movementLink}`, postData)
        .then((res) => {
          console.log(res);
          getData();
          setLoading(false);
        })
        .catch((e) => {
          console.log(e, "side Menu Transfer error");
          toast.error(e.response.data.failureMessage);
        });
    },
  });

  useEffect(
    () => {
      if (formik.values.toParentAssetCode || formik.values.toParentAssetName) {
        sedisableLocation(true);
      }
    },
    [formik.values.toParentAssetCode, formik.values.toParentAssetName]
  );
  useEffect(
    () => {
      if(formik.values.toLocationCode || formik.values.toLocationName) {
        setdisableAsset(true);
      }
    },
    [formik.values.toLocationCode, formik.values.toLocationName]
  );

  const locationHandle = (type) => {
    setLocationType(type);
    setLocationDialog(true);
  };

  const locationAsset = () => {
    // setLocationType(type)
    setAssetDialog(true);
  };

  const handlelocationClick = (name, id, code) => {
    console.log(name, id, code);
    if (
      name !== undefined &&
      name !== null &&
      id !== undefined &&
      id !== null &&
      code !== undefined &&
      code !== null
    ) {
      // if (locationType === "from") {
      //   setCurrentLocation({ name: name, id: id,code:code });
      //   setLocationType("");
      // } else {
      setToLocation({ name: name, id: id, code: code });
      //   setLocationType("");
      // }
    }

    setLocationDialog(false);
  };
  console.log();
  const handleAssetClick = (name, id, code) => {
    console.log(name, id, code);
    if (
      name !== undefined &&
      name !== null &&
      id !== undefined &&
      id !== null &&
      code !== undefined &&
      code !== null
    ) {
      setAsset({ name: name, id: id, code: code });
    }

    setAssetDialog(false);
  };
  const handleCreateClose = () => {
    setLocationDialog(false);
  };
  const handleCreateAssetClose = () => {
    setAssetDialog(false);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <Box>
        <Typography
          sx={{
            color: color.sideTitleColor,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideWeightFont,
          }}
        >
          Transfer
        </Typography>
      </Box>

      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
          p: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              color: color.sideTitle2Color,
              fontSize: color.fontSizeSide,
              fontWeight: color.sideFontWeight,
            }}
          >
            Details
          </Typography>
          {showConfirm ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography sx={{ color: "green" }}>
                Are you sure you want to transfer?
              </Typography>
              <Button
                onClick={() => {
                  formik.handleSubmit();
                  setShowConfirm(false); // Reset confirmation state
                }}
                sx={{ color: "grey", borderColor: "green" }}
                size="small"
                variant="outlined"
              >
                Yes
              </Button>
              <Button
                onClick={() => setShowConfirm(false)}
                sx={{ color: "grey", borderColor: "red" }}
                size="small"
                variant="outlined"
              >
                No
              </Button>
            </Box>
          ) : (
            <IconButton disabled={trueDisable} onClick={() => setShowConfirm(true)}>
              {loading ? <CircularProgress /> : <Save sx={{ color: "grey" }} />}
            </IconButton>
          )}
        </Box>
        <Divider />

        <Box sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Current Parent Asset
              </Typography>

              <TextField
                size={"small"}
                type="text"
                name="fromParentAssetId"
                variant="standard"
                placeholder="Enter Asset"
                value={
                  formik.values.fromParentAssetCode +
                  "-" +
                  formik.values.fromParentAssetName
                }
                inputProps={{ readOnly: true }}
                fullWidth
                // onChange={(e) => {
                //   // setFieldValue("locationId",e.target.value)
                //   setAsset({ ...asset, ["id"]: e.target.value });
                // }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton disabled onClick={() => locationAsset()}>
                        <AccountTree
                          sx={{
                            color: color.loginIcon,
                            fontWeight: 1800,
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                To Parent Asset
              </Typography>

              <TextField
                size={"small"}
                type="text"
                name="toParentAssetId"
                variant="standard"
                placeholder="Enter To Asset"
                inputProps={{readOnly:trueDisable}}
                value={
                  formik.values.toParentAssetCode +
                  "-" +
                  formik.values.toParentAssetName
                }
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {(asset.code || asset.name) && (
                        <IconButton
                          disabled={disableAsset}
                          onClick={() => {
                            setAsset({ id: "", code: "", name: "" });
                            sedisableLocation(false);
                          }}
                        >
                          <Clear sx={{ color: color.loginIcon }} />
                        </IconButton>
                      )}
                      <IconButton
                        onClick={() => locationAsset()}
                        disabled={disableAsset||trueDisable}
                      >
                        <AccountTree
                          sx={{
                            color: color.loginIcon,
                            fontWeight: 1800,
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Current Location
              </Typography>
              <TextField
                size={"small"}
                type="text"
                name="fromLocationId"
                variant="standard"
                placeholder="Enter Current Location"
                value={
                  formik.values.fromLocationCode +
                  "-" +
                  formik.values.fromLocationName
                }
                inputProps={{ readOnly: true }}
                fullWidth
                // onChange={(e) => {
                //   // setFieldValue("locationId",e.target.value)
                //   setCurrentLocation({
                //     ...currentLocation,
                //     ["name"]: e.target.value,
                //   });
                // }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        disabled
                        onClick={() => locationHandle("from")}
                      >
                        <AccountTree
                          sx={{
                            color: color.loginIcon,
                            fontWeight: 1800,
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                To Location
              </Typography>
              <TextField
                size={"small"}
                type="text"
                name="toLocationId"
                variant="standard"
                placeholder="Enter To Location"
                value={
                  formik.values.toLocationCode +
                  "-" +
                  formik.values.toLocationName
                }
                inputProps={{ readOnly: true }}
                fullWidth
                onChange={(e) => {
                  // setFieldValue("locationId",e.target.value)
                  setToLocation({ ...toLocation, ["name"]: e.target.value });
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {(toLocation.code || toLocation.name) && (
                        <IconButton
                          disabled={disableLocation || trueDisable}
                          onClick={() => {
                            setToLocation({ id: "", code: "", name: "" });
                            setdisableAsset(false);
                          }}
                        >
                          <Clear sx={{ color: color.loginIcon }} />
                        </IconButton>
                      )}
                      <IconButton
                        onClick={() => locationHandle("to")}
                        disabled={disableLocation}
                      >
                        <AccountTree
                          sx={{
                            color: color.loginIcon,
                            fontWeight: 1800,
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
          </Box>
          {/* <Box sx={{ display: "flex", gap: "1rem" }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Row
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="row"
                value={formik.values.row}
                placeholder="Enter Row"
                onChange={formik.handleChange}
                fullWidth
                sx={{
                  // width: "100%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Asile
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="asile"
                value={formik.values.asile}
                placeholder="Enter Asile"
                onChange={formik.handleChange}
                fullWidth
                sx={{
                  // width: "100%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
          </Box> */}
          <Box sx={{ display: "flex", gap: "1rem" }}>
            {/* <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Bin No
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="binNo"
                value={formik.values.binNo}
                placeholder="Enter Bin No"
                onChange={formik.handleChange}
                fullWidth
                sx={{
                  // width: "100%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box> */}
            <Box sx={{ width: "50%" }}>
              <Typography
                sx={{
                  mb: "0.7rem",
                  fontSize: color.sideLabelFont,
                  color: color.sideLabelColor,
                }}
              >
                Remark
              </Typography>
              <TextField
                variant="standard"
                size={"small"}
                type="text"
                name="remarks"
                value={formik.values.remarks}
                placeholder="Enter Remarks"
                onChange={formik.handleChange}
                fullWidth
                sx={{
                  // width: "100%",
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",
                    fontSize: "13px",

                    // "&::placeholder": {
                    //   // color: "green",
                    //   opacity: 1,
                    //   color: color.placeholderColor,
                    //   fontSize: "13px",
                    // },
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Paper>
      <Dialog
        open={locationDialog}
        maxWidth={"lr"}
        onClose={handleCreateClose}
        children={
          <LocationTreeView
            handlelocationClick={(name, id, code) => {
              handlelocationClick(name, id, code);
            }}
            handleCreateClose={handleCreateClose}
          />
        }
      />
      <Dialog
        open={assetDialog}
        onClose={handleCreateAssetClose}
        maxWidth={"lr"}
        children={
          <AssetIdFilter
            handleAssetClick={(name, id, code) => {
              handleAssetClick(name, id, code);
            }}
            handleCreateClose={handleCreateAssetClose}
          />
        }
      />
    </Box>
  );
};

export default Transfer;
